// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2961":"2d246cb2","8279":"2d246cb2"}[chunkId] + ".chunk.css";
};